/* ======================================================================
   DC PRODUCT CARD — behaviour. Spec: Del Campo/CARD-SPEC-2026-09-08.md

   Two jobs, and deliberately nothing else:
     1. a long title scrolls itself, and ONLY when it genuinely overflows
     2. the size row pages with an arrow at each end, never automatically

   Cards are re-rendered by the Section Rendering API on every filter and
   sort change, so nothing here can run once at load and assume it is done.
   Clicks are delegated from the document, and a MutationObserver picks up
   cards that arrive later.
   ====================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- long titles ---------------------------------------------
     MEASURE AFTER THE FONTS LOAD. Avant Garde Gothic and Inter are wider
     than the system fallback, so a title measured at parse time looks like
     it fits and never animates. That bug cost a review round. ---------- */
  function measureTitle(el, i) {
    if (el.classList.contains('dc-osc-off')) return;
    var track = el.querySelector('a');
    if (!track) return;

    el.classList.remove('dc-osc');
    el.style.removeProperty('--dc-shift');

    /* room left after anything sitting before the link (the Shop the Look number); 0 on normal cards */
    var lead = Math.max(0, track.getBoundingClientRect().left - el.getBoundingClientRect().left);
    var over = track.scrollWidth - (el.clientWidth - lead);
    if (over <= 2 || REDUCED) return;

    el.style.setProperty('--dc-shift', (-over) + 'px');
    /* about 30px a second with a beat at each end. The first version moved
       at 7px a second and read as completely static. */
    var dur = Math.min(14, Math.max(4, 2.5 + over / 30));
    el.style.setProperty('--dc-dur', dur.toFixed(1) + 's');
    el.style.setProperty('--dc-dly', ((i % 4) * 0.45).toFixed(2) + 's');
    el.classList.add('dc-osc');
  }

  /* ---------- size rail ------------------------------------------------ */
  function syncArrows(wrap) {
    var rail = wrap.querySelector('.dc-sizes__rail');
    var left = wrap.querySelector('.dc-sizes__ar--l');
    var right = wrap.querySelector('.dc-sizes__ar--r');
    if (!rail || !left || !right) return;

    var max = rail.scrollWidth - rail.clientWidth;
    if (max <= 2) { left.hidden = true; right.hidden = true; return; }
    left.hidden = rail.scrollLeft <= 2;
    right.hidden = rail.scrollLeft >= max - 2;
  }

  function page(wrap, dir) {
    var rail = wrap.querySelector('.dc-sizes__rail');
    if (rail) rail.scrollLeft += dir * Math.max(60, rail.clientWidth * 0.7);
  }

  /* ---------- run over whatever is on the page now --------------------- */
  function refresh(root) {
    var scope = root || document;
    var titles = scope.querySelectorAll('.product-card__title');
    for (var i = 0; i < titles.length; i++) measureTitle(titles[i], i);

    var wraps = scope.querySelectorAll('.dc-sizes');
    for (var j = 0; j < wraps.length; j++) syncArrows(wraps[j]);
  }

  /* ---------- delegated events ----------------------------------------- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('.dc-sizes__ar');
    if (!arrow) return;
    e.preventDefault();
    page(arrow.closest('.dc-sizes'),
         arrow.classList.contains('dc-sizes__ar--l') ? -1 : 1);
  });

  /* ---------- in-stock size chip = quick buy with that size ------------
     Stew, 2026-09-23. Impact's drawer fetches products/<handle> once and
     caches it, so the variant goes into the handle and the cache flag is
     cleared whenever the size changes. No drawer on the card (quick buy off
     in that section) falls back to the PDP on that variant. */
  function pickSize(chip) {
    var id = chip.getAttribute('data-variant-id');
    var card = chip.closest('product-card');
    var drawer = card && card.querySelector('quick-buy-drawer');
    if (!drawer || typeof drawer.show !== 'function') {
      window.location.href = chip.getAttribute('data-product-url') + '?variant=' + id;
      return;
    }
    var base = (drawer.getAttribute('handle') || card.getAttribute('handle') || '').split('?')[0];
    var next = base + '?variant=' + id;
    if (drawer.getAttribute('handle') !== next) {
      drawer.setAttribute('handle', next);
      drawer._hasLoaded = false;
    }
    drawer.show();
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-dc-card-size]');
    if (!chip) return;
    e.preventDefault();
    pickSize(chip);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var chip = e.target.closest && e.target.closest('[data-dc-card-size]');
    if (!chip) return;
    e.preventDefault();
    pickSize(chip);
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('dc-sizes__rail')) {
      syncArrows(t.closest('.dc-sizes'));
    }
  }, true);

  /* a title stops moving for good the moment it is touched */
  ['pointerdown', 'wheel', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var t = e.target.closest && e.target.closest('.product-card__title');
      if (!t) return;
      t.classList.add('dc-osc-off');
      t.classList.remove('dc-osc');
    }, { passive: true, capture: true });
  });

  /* ---------- lifecycle ------------------------------------------------ */
  function boot() { refresh(document); }
  /* sections that reveal hidden cards (Shop the Look tabs) re-measure just those cards */
  window.dcCardRefresh = refresh;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(boot);
  window.addEventListener('load', boot);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(boot, 150);
  });

  /* cards swapped in by filtering, sorting or paging */
  document.addEventListener('shopify:section:load', function (e) {
    refresh(e.target || document);
  });

  if (window.MutationObserver) {
    var pending;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          clearTimeout(pending);
          pending = setTimeout(boot, 80);
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
